import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext, { email }: { email: string }) {
  return this.sendEvent('auth.login', { email })
}
